module.exports = __webpack_public_path__ + "static/media/science11.7aba3d95.PNG";